import { styled } from '@mui/material'
import { ChangeEvent, MouseEvent, useCallback } from 'react'
import { intl } from '../../../i18n'
import { Checkbox } from '../../components/inputs/Checkbox'
import { Text } from '../../components/typography'
import { colorPalette } from '../../style/colorPalette'

type TicketListShowClosedToggleProps = {
  checked: boolean
  onChange: (checked: boolean) => void
}

// チケット管理表の選択肢から完了・破棄済みを出し分けるトグル。候補リストの末尾に置く。
export const TicketListShowClosedToggle = ({
  checked,
  onChange,
}: TicketListShowClosedToggleProps) => {
  // mousedown のデフォルト挙動を止めて input のフォーカスを保持し、
  // トグル操作でポップアップが閉じないようにする。
  const preventBlur = useCallback((e: MouseEvent) => e.preventDefault(), [])
  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, isChecked: boolean) =>
      onChange(isChecked),
    [onChange]
  )
  return (
    <Root onMouseDown={preventBlur}>
      <Checkbox size="s" checked={checked} onChange={handleChange} />
      <Text variant="2s" color={colorPalette.monotone[4]}>
        {intl.formatMessage({ id: 'ticketList.select.showClosed' })}
      </Text>
    </Root>
  )
}

// 候補の末尾に置くため、スクロールしても見えるよう下端に貼り付ける。
// 候補と地続きに見えないよう、境界線と背景で区切る。
const Root = styled('label')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '6px 8px',
  cursor: 'pointer',
  position: 'sticky',
  bottom: 0,
  borderTop: `1px solid ${colorPalette.monotone[2]}`,
  backgroundColor: colorPalette.monotone[1],
  '&:hover, &:focus-within': {
    backgroundColor: colorPalette.skyBlue[0],
  },
})
